import React from 'react';
import moment from "moment";
import "moment-timezone";

const TimezoneSelector = ({timezone, handleInputChange}) => {
  const timezoneList = (
    moment.tz.names()
      .reduce((options, tz) => {
        const newOption = {
          name: tz,
          offset: moment.tz(tz).utcOffset()
        };

        options = [...options, newOption];

        return options;
      }, [])
      .sort((a, b) => a.offset - b.offset)
      .map(({name, offset}) => {
        const timezone = offset ? moment.tz(name).format("Z") : "";

        return {
          key: name,
          value: timezone + "#" + name,
          text: `(GMT${timezone}) ${name}`
        };
      })
  );

  const timezoneOptions = timezoneList.map(({key, value, text}) => (
      <option
        key={key}
        value={value}
      >
        {text}
      </option>
  ));

  return (
    <select
      id="js-form-tz"
      className="form-control form-input"
      name="timezone"
      value={timezone}
      onChange={handleInputChange()}
    >
      {timezoneOptions}
    </select>
  );
};

export default TimezoneSelector;
